module.exports = __webpack_public_path__ + "img/go3.ad2f8003.png";